import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["songTitle", "total"];
  static values = { priceLookup: String };

  connect() {
    this.element.reset();
    this.onSongChange();
    this.onCatChange();
  }

  onSongChange(event) {
    var target = event?.target || $("[data-action='isc-song#onSongChange']");
    $(this.songTitleTarget).val($(target).find("option:selected").text());
  }

  onCatChange(event) {
    var target = event?.target || $("[data-action='isc-song#onCatChange']");
    console.log(target, this.totalTarget, this.priveLookupValue);
    $(this.totalTarget).html(
      (parseInt(this.priceLookupValue) * $(target).val().length).toFixed(2)
    );

    //teen is 12
    if ($(target).val().indexOf("12") >= 0) {
      $(".teen_req").show();
      $(".teen_req input").prop("required", true);
    } else {
      $(".teen_req").hide();
      $(".teen_req input").prop("required", false);
    }
    //music video
    if ($(target).val().indexOf("24") >= 0) {
      $(".video_req").show();
      $(".video_req input").prop("required", true);
    } else {
      $(".video_req").hide();
      $(".video_req input").prop("required", false);
    }
    // unsigned and unpublished
    if (
      $(target).val().indexOf("22") >= 0 &&
      $(target).val().indexOf("23") >= 0 &&
      $(target).val().length < 4
    ) {
      $(".unpublished_unsigned_req").show();
      $(".unpublished_req").hide();
      $(".unsigned_only_req").hide();
    } else {
      $(".unpublished_unsigned_req").hide();

      $(".unsigned_only_req").hide();
      $(".unpublished_req").hide();

      //unsigned
      if ($(target).val().indexOf("22") >= 0 && $(target).val().length < 2) {
        $(".unsigned_only_req").show();
      } else {
        $(".unsigned_only_req").hide();
      }

      //unpublished
      if ($(target).val().indexOf("23") >= 0 && $(target).val().length < 2) {
        $(".unpublished_req").show();
      } else {
        $(".unpublished_req").hide();
      }
    }

    if ($(target).val().indexOf("25") >= 0) {
      $(".lyrics_field").parent("div.form-group").addClass("required highlite");
      $(".lyrics_field").siblings("textarea").prop("required", true);
    } else {
      $(".lyrics_field")
        .parent("div.form-group")
        .removeClass("required highlite");
      $(".lyrics_field").siblings("textarea").prop("required", false);
    }
  }
}
